import { axiosInstance } from "@/lib/axiosInstance";

export interface OfferType {
  id: string;
  application_id: string;
  student_id: string;
  internship_id: string;
  stipend: number;
  start_date: string;
  end_date: string;
  offer_letter_url: string;
  status: string; // "pending", "accepted", "declined", "expired"
  responded_at?: string;
  expires_at: string;
  created_at: string;
  /**
   * Snapshot pushed by the recruiter when the offer is extended. Null only for
   * rows created before the backend added these columns — fall back to
   * internship_id, which is always present.
   */
  internship_title: string | null;
  company_name: string | null;
}

export const fetchOffers = async () => {
  const res = await axiosInstance.get("v1/offers/");
  let data = res.data;
  // Handle stringified JSON if necessary (consistent with other services)
  if (typeof data === "string") {
    try { data = JSON.parse(data); } catch (e) { }
  }
  return data?.data || data;
};

export const getOfferById = async (offerId: string) => {
  const res = await axiosInstance.get(`v1/offers/${offerId}`);
  let data = res.data;
  if (typeof data === "string") {
    try { data = JSON.parse(data); } catch (e) { }
  }
  return data?.data || data;
};

export const acceptOffer = async (offerId: string) => {
  const res = await axiosInstance.patch(`v1/offers/${offerId}/accept`);
  return res.data;
};

export const declineOffer = async (offerId: string) => {
  const res = await axiosInstance.patch(`v1/offers/${offerId}/decline`);
  return res.data;
};

// pushOffer / fetchStudentOffersInternal were removed: both called
// internal/v1 service-to-service routes that take a student id in the path and
// currently require no auth. Neither was wired to any screen, and the public
// `v1/offers/` endpoint above already covers what this app needs.
